// Font loading optimization utility
// This helps prevent fonts from being reloaded on every page refresh

import { storageManager } from './storageManager';

const FONT_CACHE_KEY = 'quran_fonts_loaded';
const FONT_CACHE_DURATION = 30 * 24 * 60 * 60 * 1000; // 30 days

export class FontOptimizer {
  static isFontCached() {
    const cached = storageManager.getItem(FONT_CACHE_KEY);
    if (!cached) return false;
    
    const { timestamp } = cached;
    return Date.now() - timestamp < FONT_CACHE_DURATION;
  }

  static markFontsAsLoaded() {
    storageManager.setItem(FONT_CACHE_KEY, {
      timestamp: Date.now()
    });
  }

  static preloadCriticalFonts() {
    // Only preload if not already cached
    if (this.isFontCached()) return;

    const criticalFonts = [
      '/fonts/AlQuran-IndoPak-by-QuranWBW.v.4.2.2-WL.ttf',
      '/fonts/Jameel-Noori-Nastaleeq-Regular.ttf',
      '/fonts/Indopak%20Nastaleeq%20font.ttf'
    ];

    criticalFonts.forEach(fontPath => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'font';
      link.href = fontPath;
      link.type = 'font/ttf';
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });
  }

  static optimizeFontDisplay() {
    // Set font-display: swap for better performance
    const style = document.createElement('style');
    style.textContent = `
      @font-face {
        font-family: 'AlQuran-IndoPak';
        font-display: swap;
      }
      @font-face {
        font-family: 'Jameel-Urdu';
        font-display: swap;
      }
      @font-face {
        font-family: 'Madinah-Nastaleeq';
        font-display: swap;
      }
    `;
    document.head.appendChild(style);
  }
}

// Auto-initialize when imported
if (typeof window !== 'undefined') {
  FontOptimizer.preloadCriticalFonts();
  FontOptimizer.optimizeFontDisplay();

  // Font caching is owned by public/sw.js (single SW). Do not register font-cache-sw.js.

  // Listen for font loading events
  if ('fonts' in document) {
    Promise.all([
      document.fonts.load('1em AlQuran-IndoPak'),
      document.fonts.load('1em Jameel-Urdu'),
      document.fonts.load('1em Madinah-Nastaleeq')
    ]).then(() => {
      FontOptimizer.markFontsAsLoaded();
    });
  }
}
